export class DrugDto{
    apid: string;
    vpid: string;
    searchText: string;
}


// WEBPACK FOOTER //
// ./ClientApp/dto/DrugDto.ts